var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZurich(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 951.26007 571.00372",
    width: 951.26007,
    height: 571.00372,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#040506;}"))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_206",
    "data-name": "Grupo 206",
    transform: "translate(-199.66,-249.99997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_313",
    "data-name": "Trazado 313",
    className: "cls-1",
    d: "m 786.23,404.22 a 154.15,154.15 0 0 1 -267.89,104.22 77.24,77.24 0 0 1 25.46,-7.59 150.69,150.69 0 0 1 25.09,-2.14 337.82,337.82 0 0 1 52,5.29 270.5,270.5 0 0 0 44.24,4.85 h 2.14 a 62.48,62.48 0 0 0 37.44,-12.33 81,81 0 0 0 25.23,-33.41 102,102 0 0 0 6.79,-19.29 l -6.92,-1.71 c -0.92,2.14 -1.72,3.56 -2.15,4.61 a 78.5,78.5 0 0 1 -22.91,26.14 62.35,62.35 0 0 1 -16.48,7.93 87.14,87.14 0 0 1 -26.88,3.21 c -5.31,0 -12.21,-0.24 -20.38,-0.82 L 618.31,482 q -15.7,-1 -23.57,-1 -9.16,0 -18.3,0.92 L 703.93,311.25 H 543.37 l -12.54,48.39 7.48,1.72 a 43.65,43.65 0 0 1 2.15,-4 61.53,61.53 0 0 1 15.77,-18.65 39.4,39.4 0 0 1 15.66,-6.43 222.58,222.58 0 0 1 38.24,-2.89 h 13.71 l 13.83,-0.11 -128.2,168.46 A 154.12,154.12 0 0 1 632,250 v 0 a 154.31,154.31 0 0 1 154.23,154.22 z",
    style: {
      fill: "#040506"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_205",
    "data-name": "Grupo 205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_314",
    "data-name": "Trazado 314",
    className: "cls-1",
    d: "m 1055.21,811.13 a 28.41,28.41 0 0 0 4,4.72 h -48 c 0.92,-0.8 1.6,-1.5 2.14,-2 a 20.13,20.13 0 0 0 5.4,-7.82 23.83,23.83 0 0 0 1.63,-6.43 99.43,99.43 0 0 0 0.68,-15.33 V 747.7 h -67.33 v 36.43 c 0,2.76 0,5.76 0.11,9 a 34,34 0 0 0 2.16,13.12 32.27,32.27 0 0 0 2.43,4.71 27.79,27.79 0 0 0 4,4.95 h -47.61 c 0.68,-0.68 1.26,-1.13 1.6,-1.5 a 20.66,20.66 0 0 0 5.77,-8.57 23.35,23.35 0 0 0 1.5,-5.87 134.05,134.05 0 0 0 0.56,-15.9 v -82.24 l -0.11,-9.45 a 44.49,44.49 0 0 0 -1.61,-15.9 23.94,23.94 0 0 0 -2.53,-5.06 42,42 0 0 0 -5,-5.87 h 48.14 c -0.82,0.79 -1.4,1.27 -1.74,1.61 a 31.8,31.8 0 0 0 -6.22,10.37 26.08,26.08 0 0 0 -1.15,6.43 c -0.35,4.14 -0.45,9.56 -0.45,17.85 v 27.41 H 1021 v -36.43 a 51.42,51.42 0 0 0 -1.6,-15.79 21.4,21.4 0 0 0 -2.55,-5.19 20.75,20.75 0 0 0 -5.4,-6.21 h 49 a 19.21,19.21 0 0 0 -5.87,6.42 23.35,23.35 0 0 0 -2.43,5.51 60.81,60.81 0 0 0 -1.6,15.9 v 8.88 l -0.13,82.7 c 0,0.79 0,3.34 0.13,7.82 a 31.77,31.77 0 0 0 2,13.59 17,17 0 0 0 2.66,4.71 z",
    style: {
      fill: "#040506"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_315",
    "data-name": "Trazado 315",
    className: "cls-1",
    d: "m 889.83,785.09 v 27.31 c -1.05,0.34 -2,0.58 -2.43,0.68 a 134.65,134.65 0 0 1 -42.28,6.8 88.45,88.45 0 0 1 -56.12,-17.38 73.21,73.21 0 0 1 -27.42,-59 76.78,76.78 0 0 1 28.61,-61.5 83.28,83.28 0 0 1 20.62,-12.19 107.57,107.57 0 0 1 42.86,-8 125.37,125.37 0 0 1 26.49,2.64 82,82 0 0 1 9.11,2.42 v 28.33 a 45.49,45.49 0 0 0 -12.27,-6.74 70.27,70.27 0 0 0 -27.07,-5.4 59.32,59.32 0 0 0 -29,7.14 48.13,48.13 0 0 0 -13.59,11.16 62.18,62.18 0 0 0 -13.59,40.55 60.4,60.4 0 0 0 15,41.58 50.72,50.72 0 0 0 38.57,16.24 65.92,65.92 0 0 0 26.28,-5.63 85.09,85.09 0 0 0 9.21,-4.61 c 2.19,-1.29 3.44,-2.08 7.02,-4.4 z",
    style: {
      fill: "#040506"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_316",
    "data-name": "Trazado 316",
    className: "cls-1",
    d: "m 738.35,815.93 h -47.68 a 41.34,41.34 0 0 0 4.6,-5.29 31.76,31.76 0 0 0 2.43,-4.29 45.14,45.14 0 0 0 2.3,-14.63 v -98.93 a 54.17,54.17 0 0 0 -1.63,-16.24 17.12,17.12 0 0 0 -2.29,-4.85 25.16,25.16 0 0 0 -5.53,-6 h 48.26 a 20.51,20.51 0 0 0 -5.76,6.43 23.69,23.69 0 0 0 -2.15,4.59 53.36,53.36 0 0 0 -1.6,16.93 l -0.11,8.76 V 793 a 41.07,41.07 0 0 0 2.14,13.24 32.12,32.12 0 0 0 2.42,4.61 21.75,21.75 0 0 0 4.6,5.08 z",
    style: {
      fill: "#040506"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_317",
    "data-name": "Trazado 317",
    className: "cls-1",
    d: "m 673.05,811.37 c -2.14,-2 -4.41,-4 -6.56,-6 -5.18,-5 -9.9,-9.8 -17,-17.38 -4.48,-4.85 -8.17,-8.88 -10.93,-12.22 l -23.38,-27.52 a 56.84,56.84 0 0 0 6.69,-2.31 66.65,66.65 0 0 0 18.53,-10.72 37.05,37.05 0 0 0 13.6,-28.67 34.57,34.57 0 0 0 -10.1,-24.65 48.56,48.56 0 0 0 -24.41,-13.48 121.36,121.36 0 0 0 -25.71,-2.63 c -4.48,-0.13 -9.09,-0.24 -13.93,-0.24 h -38.79 a 21.78,21.78 0 0 1 5.05,5.77 18.13,18.13 0 0 1 2.66,5.4 57.12,57.12 0 0 1 1.5,16 v 98.58 a 40.94,40.94 0 0 1 -1.73,14.51 17.33,17.33 0 0 1 -2.64,4.71 28.6,28.6 0 0 1 -4.95,5.3 h 47.79 a 35.08,35.08 0 0 1 -4.16,-5 20.18,20.18 0 0 1 -2.58,-4.42 39.15,39.15 0 0 1 -2,-14 v -41.3 l 27.86,33.42 c 1.25,1.6 3.33,4 6.21,7.24 3.24,3.69 5.66,6.43 7.27,8.06 a 64.59,64.59 0 0 0 15.53,12.34 31.86,31.86 0 0 0 15,3.56 h 26.59 c -2.54,-1.93 -3.46,-2.72 -5.41,-4.35 z m -63.93,-79.6 a 48.72,48.72 0 0 1 -18.88,6.11 57.36,57.36 0 0 1 -7.84,0.69 q -1.2,0.06 -2.4,0 v -55.72 h 3.9 a 77.41,77.41 0 0 1 20.27,2.42 29.77,29.77 0 0 1 10.14,5.42 23.4,23.4 0 0 1 7.69,18.54 24.59,24.59 0 0 1 -5.87,16.93 29.34,29.34 0 0 1 -7,5.61 z",
    style: {
      fill: "#040506"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_318",
    "data-name": "Trazado 318",
    className: "cls-1",
    d: "m 516.52,665.66 a 20.93,20.93 0 0 0 -5.88,6.23 19.12,19.12 0 0 0 -2.64,6.11 51.89,51.89 0 0 0 -1.27,13.72 v 1.71 l 0.13,8.57 v 43.23 a 235.53,235.53 0 0 1 -1.06,26.77 49,49 0 0 1 -12.09,29.13 57.06,57.06 0 0 1 -22.35,15 91.49,91.49 0 0 1 -30.17,4.71 64.43,64.43 0 0 1 -53,-21.75 48.93,48.93 0 0 1 -10.59,-27.64 C 377,765.06 377,761 377,745 v -43.08 l -0.13,-8.57 V 684 a 28.23,28.23 0 0 0 -0.92,-6.9 16.8,16.8 0 0 0 -2.14,-5.18 17.31,17.31 0 0 0 -5.42,-6.11 h 48.84 c -0.58,0.58 -0.92,1.05 -1.16,1.26 A 33.3,33.3 0 0 0 410,678 a 32,32 0 0 0 -1.16,6.8 c -0.24,4.5 -0.34,8.74 -0.34,17.51 v 45 l 0.1,12.43 a 44.3,44.3 0 0 0 5.53,27.44 34.86,34.86 0 0 0 29.26,12.66 43.41,43.41 0 0 0 10.71,-1.16 28.13,28.13 0 0 0 22.33,-24 166.64,166.64 0 0 0 1.29,-25.46 v -57 a 59.91,59.91 0 0 0 -1.29,-15.8 21.37,21.37 0 0 0 -2.29,-5.06 19.35,19.35 0 0 0 -5.42,-5.76 z",
    style: {
      fill: "#040506"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_319",
    "data-name": "Trazado 319",
    className: "cls-1",
    d: "m 344.75,781.54 -15,34.29 H 199.66 l 91.92,-131.42 h -17.39 c -3.68,0 -7.6,0 -11.74,0.24 a 139.31,139.31 0 0 0 -21.09,1.73 118.76,118.76 0 0 0 -21.3,6.09 74.2,74.2 0 0 0 -11.06,5.18 l 14.62,-32.14 h 118.06 l -91,131.41 h 23 c 4.85,0 8.88,0 12,-0.1 a 162.11,162.11 0 0 0 23.58,-2.15 102.84,102.84 0 0 0 24.3,-7.48 106.27,106.27 0 0 0 11.19,-5.65 z",
    style: {
      fill: "#040506"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_320",
    "data-name": "Trazado 320",
    className: "cls-1",
    d: "m 1119.83,587.93 a 31,31 0 1 0 31.09,31.07 31,31 0 0 0 -31.09,-31.07 z m 0,58.5 a 27.54,27.54 0 1 1 27.54,-27.53 0.49,0.49 0 0 1 0,0.12 27.48,27.48 0 0 1 -27.54,27.41 z",
    style: {
      fill: "#040506"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_321",
    "data-name": "Trazado 321",
    className: "cls-1",
    d: "m 1127,623.4 a 6.69,6.69 0 0 0 -5.74,-4.61 v 0 a 8.92,8.92 0 0 0 8.4,-8.77 c 0,-6.9 -4.29,-9.79 -11.06,-9.79 h -9.79 v 37.85 h 3.68 V 620.2 h 3.11 a 7.28,7.28 0 0 1 8.3,4.95 l 5.4,12.85 h 4.11 z m -14.51,-6.58 v -13.46 h 3.93 c 5,0 9.55,0.34 9.55,6.56 0,5.29 -5.07,6.9 -9.45,6.9 z",
    style: {
      fill: "#040506"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZurich);
export default __webpack_public_path__ + "static/media/zurich.59a1c0769c7dd7fb81a70e0c89bd1ce8.svg";
export { ForwardRef as ReactComponent };